import { createI18n } from "vue-i18n";
import en from "./en-EN.js";
import tr from "./tr-TR.js";

export const messages = {
  en,
  tr,
};

export const locales = [
  // default option must be last item
  {
    code: "tr",
    iso: "tr-TR",
    name: "TR",
    icon: "tr-TR.svg",
  },
  {
    code: "en",
    iso: "en-EN",
    name: "EN",
    icon: "en-EN.svg",
  },
];

export const i18n = createI18n({
  legacy: false,
  locale: "en",
  fallbackLocale: "en-EN",
  messages,
});

export const setInitialLang = () => {
  const langCode =
    localStorage.getItem("langCode") ||
    navigator.language.split("-")[0] ||
    "en";
  if (i18n.mode === "legacy") {
    i18n.global.locale = langCode;
  } else {
    i18n.global.locale.value = langCode;
  }
};

setInitialLang();
